// We assume this constant exists. If not, create src/chatbot/utils/constants/clientConstants.js
import { CHATBOT_NAME } from "../../utils/constants/clientConstants";

export class ChatMessage {
    constructor(
        message, 
        sender, 
        sentAt, 
        mediaPaths,
        debugSources
    ) {
        this.message = message;
        this.sender = sender;
        this.sentAt = sentAt;
        this.media = mediaPaths;
        this.debugSources = debugSources;
    }

    static botMessage(message, mediaPaths, debugSources) {
        return new ChatMessage(message, "bot", new Date(), mediaPaths ?? [], debugSources);
    }

    static userMessage(message) {
        return new ChatMessage(message, "user", new Date(), []);
    }

    static errorMessage() {
        return new ChatMessage("Fehler beim Laden der Antwort. Bitte versuchen Sie es später erneut.", "bot", new Date(), []);
    }
}